<app-sort [sortOptions]="sortOptions$ | async" [sort]="sort$ | async" (sortChange)="handleSort($event)" class="mr-4"></app-sort>
<app-gallery-view-mode></app-gallery-view-mode>